
const angular = require('angular')
const _ = require('lodash')
import accessStore from '../../../../services/locations/AccessStore'
import {formatPostalAddress} from "../../../../services/locations/locationAddress/util";

angular.module('clientDashboardApp').controller("EmailAlertsSettingsController", function($scope, userManagerService, userService, accountsService, locationService) {
  
  const ctrl = this

  ctrl.toNameAddress = function( location){
    let nameAddress=""
    if(location.name){
      nameAddress+=location.name
      if(location.address)
        nameAddress+= " - " + formatPostalAddress(location.address)
    }
    return nameAddress
  }

  accountsService.listAccounts().then(resp => {
    this.accounts = resp.accounts
  })

  let refreshUsers = false

  this.loadUsers = (query) => {
    if (!ctrl.users) {
      $scope.usersInitializing = true
    }
    if (ctrl.users && !refreshUsers && !query) {
      return
    }
    if($scope.isAdmin) {
      userManagerService.listAlertUsers(query || "", 0, 200).then(response => {
        //Reason for verbosity in the filter is because true/null are the same, and false is what we want to ignore
        ctrl.users = response.users.filter(user => user.enabled != false)
        if (query && query !== "") {
          refreshUsers = true
        }
        let additionalUsers= ($scope.alert.recipients.find(item => item.type === "specificUsers").userIds || []).concat($scope.alert.excludeUsers)
        if (additionalUsers.length && _.intersection(additionalUsers, ctrl.users.map(user => user.id)).length !== additionalUsers.length) {
          let additionalUsersToQuery = _.difference(additionalUsers,ctrl.users.map(user => user.id));
          userManagerService.listAlertUsers("", 0, 200, additionalUsersToQuery).then(selectedUsersResponse => {
            let allListedUsers = _.flatMap(selectedUsersResponse, function(response) {
              return response.data.users
            })
            ctrl.users = ctrl.users.concat(allListedUsers)
            $scope.usersInitializing = false
          })
        } else {
          $scope.usersInitializing = false
        }
      })
    } else {
      ctrl.users = [userService.getCurrentUser()] // Standard users cannot GET /v5/users
      $scope.usersInitializing = false
      $scope.currentUserIsRecipient = $scope.alert.recipients.findIndex(x => (x["userIds"] || []).includes(userService.getCurrentUser()["userId"])) !== -1
      const totalRecipients = $scope.alert.recipients.filter(x => x.type === "specificUsers").map(x => x["userIds"].length).reduce((acc, n) => acc + n)
      $scope.totalOtherRecipients = totalRecipients - ($scope.currentUserIsRecipient ? 1 : 0)
    }
  }

  $scope.searchUsersFilter = (query) => {
    this.loadUsers(query)
  }

  this.onAccountChanged = function() {
    ctrl.loadUsers()
  }

  ctrl.toggleDelayMins = () => {
    if (ctrl.enableThrottling) {
      $scope.alert.trigger.delayMins = ctrl.lastDelayMins || 15;
    } else {
      ctrl.lastDelayMins = $scope.alert.trigger.delayMins;
      $scope.alert.trigger.delayMins = 0;
    }
  }

  ctrl.enableThrottling = $scope.alert.trigger && $scope.alert.trigger.delayMins > 0;

  this.loadUsers()

  function reloadRecipients() {
    ctrl.recipients = {
      users: {
        type: "specificUsers",
        userIds: []
      },
      roles: {
        type: "byRole",
        roles: []
      }
    }
    $scope.alert.recipients = [ctrl.recipients.users, ctrl.recipients.roles]
  }

  // Initialize recipients
  ctrl.recipients = {}

  if ($scope.alert && $scope.alert.recipients.length) {
    $scope.alert.recipients.forEach(recipientCollection => {
      switch (recipientCollection.type) {
        case 'byRole': ctrl.recipients.roles = recipientCollection; break;
        case 'specificUsers': ctrl.recipients.users = recipientCollection; break;
      }
    })
  } else {
    reloadRecipients();
  }

  // Uses in-memory cache of locations, and limits results to maximum of 200 locations
  // Too many locations causes sluggishness in the UI
  $scope.searchLocationsFilter = (searchQuery) => {
    const maxResultsInSearchBox = 200

    const filterBySearchQuery = (locations, searchQuery) => {
      return locations
        .filter(x => x["name"].toLowerCase().includes(searchQuery.toLowerCase()))
        .sort((a, b) => a["name"].localeCompare(b["name"]))
        .slice(0, maxResultsInSearchBox)
    }

    const allLocations = $scope.locations

    function filterByAccounts(thing) {
      return !$scope.alert.filter || !$scope.alert.filter.accountIds || $scope.alert.filter.accountIds.indexOf(thing.primaryAccountId) !== -1
    }

    let pagedLocations = filterBySearchQuery(allLocations.filter(x => x["type"] === "Locations").filter(filterByAccounts), searchQuery)
    let groups = filterBySearchQuery(allLocations.filter(x => x["type"] !== "Locations").filter(filterByAccounts), searchQuery)

    if ($scope.alert.filter && $scope.alert.filter.locationIds && $scope.alert.filter.locationIds.length) {
      window.allLocations = allLocations
      pagedLocations = _.uniq(pagedLocations.concat(_.filter(allLocations, loc => $scope.alert.filter.locationIds.indexOf(loc.id.replace(/^location-/, "")) !== -1)))
    }
    // find the location filter field
    // foreach selected location, find the location in allLocations and make sure it's in the paged data set
    // $scope.alert


    $scope.pagedLocations = groups.concat(pagedLocations)
  }

  $scope.queryLocations = (query) => {
    $scope.locationsLoading = true
    accessStore.onceLoaded().then(() => {
      const locs = accessStore.locations
        .map(item => ({...item, id: `location-${item.id}`, type: "Locations", nameAddress: ctrl.toNameAddress(item) ,display: "<i class='fas fa-map-marker-alt'></i> " + ctrl.toNameAddress(item)}))
      const groups = accessStore.groups
        .map(item => ({...item, id: `group-${item.id}`, type: "Groups", nameAddress: item.name, display: "<i class='fas fa-map-marker-plus'></i> " + item.name + " (" + item.totalLocations + ")"}))
       $scope.locations = locs.concat(groups)
      $scope.searchLocationsFilter("")
      $scope.locationsLoading = false
    })
  }

  $scope.addExcludedUser = (users) => {
    $scope.alert.excludeUsers = users;
  }

  // Pre-load locations
  $scope.locations = []
  $scope.pagedLocations = []
  $scope.queryLocations("")
  $scope.addExcludedUser($scope.alert.excludeUsers);

  const desiredOrder = ["Groups", "Locations"]
  $scope.filterLocationGroups = function(groups) {      // Used to control the order that the option groups appear in the location ui-select
    return _.sortBy(groups, group => desiredOrder.indexOf(group.name))
  }


})
